import React from "react";
import CalendarioFull from "../components/CalendarioFull";
import DashboardLayout from "../../../layouts/DashboardLayout";

const CalendarioPage = () => {
  return (
    <DashboardLayout>
    <div style={{ padding: 20 }}>
      <h2>Módulo de Coordinaciones</h2>
      <CalendarioFull />
    </div>
    </DashboardLayout>
  );
};

export default CalendarioPage;
